import _ from 'lodash'
import { date } from 'quasar'
export default {
  studentList,
  autoCompleteOptions,
  stateAbbrev
}

function autoCompleteOptions (state, getters, rootState) {
  return state.autoCompleteList.map(student => { 
    const fullName = student.STUDENT_LAST_NAME + ', ' + student.STUDENT_FIRST_NAME
    return { label: fullName, value: fullName, item: student }
  })
}

function studentList (state, getters, rootState) {
  return state.list.map(student => {
    if (student.ADDRESSES) {
      _.each(student.ADDRESSES[0], (addressValue, addressKey) => {
        student[addressKey] = addressValue
      }) 
      _.each(student.STATE, (stateValue, stateKey) => {
        student[stateKey] = stateValue
      })
    }
    if (student.DRIVERS_LICENSE) {
      _.each(student.DRIVERS_LICENSE[0], (addressValue, addressKey) => {
        student[addressKey] = addressValue
      }) 
      _.each(student.STATE, (stateValue, stateKey) => {
        student[stateKey] = stateValue
      })
    }
    student.DRIVERS_LICENSE_NUMBER = student.DRIVERS_LICENSE
    student.STUDENT_DOB = student.STUDENT_DOB
    student.ACTIVE_IND = !!student.ACTIVE_IND
    student.ACTIVE_STATUS = (student.ACTIVE_IND) ? 'Active' : 'Inactive'
    return student
  })
}

function stateAbbrev (state, getters, rootState) {
  const stateItem = _.filter(rootState.shared.states, item => {
    return (item.LK_STATE_ID === state.driversLicenseForm.LK_STATE_ID) ? item : null
  })
  const stateAbbrev = (stateItem[0]) ? stateItem[0].STATE.trim() : null
  return stateAbbrev
}
